import styles from './EnforcePlentyPropositionBanner.module.scss'
import { EnforcePlentyPropositionBannerProps } from './types'
import { Button, Card, Heading } from '@boltenergy-be/design-system'
import parse from 'html-react-parser'
import { useTranslation } from 'next-i18next/pages'

const EnforcePlentyPropositionBanner = ({ showPlentyModal, position }: EnforcePlentyPropositionBannerProps) => {
  // i18n
  const { t } = useTranslation('simulation')

  return (
    <Card className={styles['plenty-conditions-card']} border={false} data-position={position}>
      <Heading as="h3" variant="h6">
        {t('proposition.plenty.enforcedBanner.title')}
      </Heading>
      <p>{parse(t('proposition.plenty.enforcedBanner.description'))}</p>
      <Button representation="link" onClick={showPlentyModal}>
        {t('proposition.plenty.enforcedBanner.action')}
      </Button>
    </Card>
  )
}

export default EnforcePlentyPropositionBanner
